(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-slider')) {
    customElements.define(
      'announcement-slider',
      class AnnouncementSlider extends HTMLElement {
        connectedCallback() {
          if (!this.initialized) this.initialize();

          this.connectHeaderTransition();

          if (this.slides.length < 2) return;

          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          this.startAutoRotate();
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.removeEventListener('visibilitychange', this.handleVisibilityChange);
          window.removeEventListener('scroll', this.handleHeaderScroll);
          this.resizeObserver?.disconnect();
          this.header?.classList.remove('announcement-bar-scrolled');
          this.stopAutoRotate();
        }

        connectHeaderTransition() {
          this.sectionElement = this.closest('.announcement-bar-section');
          this.header = document.querySelector('header.header_new');

          if (!this.sectionElement || !this.header) return;

          this.handleHeaderScroll = () => {
            if (this.scrollFrame) return;

            this.scrollFrame = window.requestAnimationFrame(() => {
              const isScrolled = window.scrollY > 8;
              this.sectionElement.classList.toggle('is-hidden', isScrolled);
              this.header.classList.toggle('announcement-bar-scrolled', isScrolled);
              this.scrollFrame = undefined;
            });
          };
          this.resizeObserver = new ResizeObserver(() => {
            document.documentElement.style.setProperty('--announcement-bar-height', `${this.sectionElement.offsetHeight}px`);
          });
          this.resizeObserver.observe(this.sectionElement);
          window.addEventListener('scroll', this.handleHeaderScroll, { passive: true });
          document.documentElement.style.setProperty('--announcement-bar-height', `${this.sectionElement.offsetHeight}px`);
          this.handleHeaderScroll();
        }

        initialize() {
          this.initialized = true;
          this.slides = Array.from(this.querySelectorAll('[data-announcement-slide]'));
          this.previousButton = this.querySelector('[name="previous"]');
          this.nextButton = this.querySelector('[name="next"]');
          this.currentIndex = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
          this.autoRotate = this.dataset.autoRotate === 'true';
          this.rotationInterval = Number(this.dataset.rotationInterval) || 5000;
          this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.designMode = window.Shopify?.designMode === true;

          if (this.slides.length < 2 || !this.previousButton || !this.nextButton) return;

          this.previousButton.addEventListener('click', () => this.show(this.currentIndex - 1));
          this.nextButton.addEventListener('click', () => this.show(this.currentIndex + 1));
          this.addEventListener('pointerenter', () => this.stopAutoRotate());
          this.addEventListener('pointerleave', () => this.startAutoRotate());
          this.addEventListener('focusin', () => this.stopAutoRotate());
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.startAutoRotate();
          });
          this.handleBlockSelect = (event) => {
            const selectedIndex = this.slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
            if (selectedIndex >= 0) {
              this.stopAutoRotate();
              this.show(selectedIndex, false);
            }
          };
          this.handleVisibilityChange = () => {
            if (document.hidden) {
              this.stopAutoRotate();
            } else {
              this.startAutoRotate();
            }
          };
          this.updateControlColor();
        }

        show(index, resetTimer = true) {
          this.currentIndex = (index + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            slide.hidden = slideIndex !== this.currentIndex;
          });
          this.updateControlColor();
          if (resetTimer) this.restartAutoRotate();
        }

        updateControlColor() {
          const activeSlide = this.slides[this.currentIndex];
          if (activeSlide) this.style.color = window.getComputedStyle(activeSlide).color;
        }

        startAutoRotate() {
          if (
            !this.autoRotate ||
            this.reduceMotion ||
            this.designMode ||
            document.hidden ||
            this.matches(':hover') ||
            this.contains(document.activeElement) ||
            this.timer
          ) return;

          this.timer = window.setInterval(() => {
            this.show(this.currentIndex + 1, false);
          }, this.rotationInterval);
        }

        stopAutoRotate() {
          window.clearInterval(this.timer);
          this.timer = undefined;
        }

        restartAutoRotate() {
          this.stopAutoRotate();
          this.startAutoRotate();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
